import { render, staticRenderFns } from "./formSubmit.vue?vue&type=template&id=5d45f3ea&scoped=true&"
import script from "./formSubmit.vue?vue&type=script&lang=js&"
export * from "./formSubmit.vue?vue&type=script&lang=js&"
import style0 from "./formSubmit.vue?vue&type=style&index=0&id=5d45f3ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d45f3ea",
  null
  
)

export default component.exports